import React from "react";
import { Label } from "../ui/label";

export const CUISINE_TYPES = [
  "Coffee Shop", "Bakery", "Fine Dining", "Fast Food", "Food Truck", "Wine Bar",
  "Bar/Pub", "Pizzeria", "Chinese", "Italian", "Indian", "South Indian", "Muslim",
  "Seafood", "Thai", "Korean", "Mexican", "Naga Food", "Buffet & Cafeteria",
];

export default function CuisineSelect({ value = [], onChange, label = "Cuisines" }) {
  const selected = Array.isArray(value) ? value : [];
  const toggle = (c) => {
    const next = selected.includes(c) ? selected.filter((x) => x !== c) : [...selected, c];
    onChange?.(next);
  };
  return (
    <div className="space-y-2" data-testid="cuisine-select">
      <Label>{label}</Label>
      <p className="-mt-1 text-xs text-ink-soft">Pick all that apply — customers filter restaurants by these.</p>
      <div className="flex flex-wrap gap-2">
        {CUISINE_TYPES.map((c) => {
          const on = selected.includes(c);
          return (
            <button
              type="button"
              key={c}
              onClick={() => toggle(c)}
              data-testid={`cuisine-chip-${c.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
              aria-pressed={on}
              className={`rounded-full border px-3 py-1.5 text-sm font-medium transition ${
                on ? "border-brand bg-brand text-white" : "border-surface-300 bg-white text-ink-soft hover:border-brand"
              }`}
            >
              {c}
            </button>
          );
        })}
      </div>
    </div>
  );
}
